<template>
  <modal v-if="modalOpen" @close="closeModal" @mask-click="closeModal" :container-width="'80vw'" :hide-footer="true">
    <div slot="header">
      <h2>{{ title }}</h2>
    </div>
    <div slot="body">
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col">
            <div :id="advancedSearchProps.id" class="search-inner">
              <slot>
                <component 
                  :advanced-search-props="advancedSearchProps"
                  :is="innerComponent"
                  :search="search"
                  @item-click="onItemClick"
                  @item-created="onItemCreated"
                  @list-item-clicked="$emit('list-item-clicked', $event)" />
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import ModalComponent from '@/components/ModalComponent.vue';
import mixin from '@/mixins/modalNavigation.js';

export default {
  mixins: [mixin],
  components: {
    'modal': ModalComponent,
  },
  props: {
    innerComponent: {
      required: true
    },
    search: {
      default: null
    },
    /** Eigenschappen die aan het grid worden gebind */
    advancedSearchProps: {},
    isOpen: {
      default: false
    }
  },
  data () {
    const self = this;
    return {
      isBusy: false,
      searchkey: null
    };
  },
  methods: {
    showModal() {
      this.modalOpen = true;
      this.addNavigationItem();
      this.$nextTick(() => {
        if (this.$el && this.$el.focus) {
          this.$el.focus();
        }
      });
    },
    onSave () {
      this.$emit('continue');
      this.closeModal();
    },
    closeModal () {
      this.close();
    },
    onItemClick(item) {
      this.$emit('item-click', item);
    },
    onItemCreated(item) {
      this.$emit('item-created', item);
    },
    close() {
      this.modalOpen = false;
      this.removeNavigationItem();
      this.$emit('close');
    }
  },
  computed: {
    title () {
      return this.advancedSearchProps.title;
    }
  },
  watch: {
    isOpen: {
      handler: function (newvalue, oldvalue) {
        if (newvalue === true && !oldvalue) {
          this.$nextTick(() => this.showModal());
        }
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.search-inner {
  height: 80vh;
  box-sizing: border-box;
}
</style>
